module.exports = __webpack_public_path__ + "assets/btn_quick_use_pressed.beed08e8.svg";